export default __webpack_public_path__ + "editor.6b380339f0be795d.svg";